import * as React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridRowId,
  GridToolbar,
} from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'
import { toast } from 'react-hot-toast'
import { Box } from '@mui/material'
import SearchBar from './SearchBar'
import ExportButton from './ExportButton'

interface MilestoneRow {
  id: string
  value: number
  title: string
}

const searchFields = [
  { value: 'title', label: 'Titre' },
  { value: 'value', label: 'Seuil' },
  { value: 'id', label: 'ID' },
]

export default function MilestoneDataGrid({
  milestones,
}: {
  milestones: MilestoneRow[]
}) {
  const [rows, setRows] = React.useState(milestones)
  const navigate = useNavigate()

  React.useEffect(() => {
    setRows(milestones)
  }, [milestones])

  const handleDeleteClick = (id: GridRowId) => () => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer ce jalon ?`)) {
      axios
        .delete(`${base_url}/milestone/${id}`)
        .then(() => {
          toast.success('Jalon supprimé avec succès.')
          setRows((prevRows) => prevRows.filter((row) => row.id !== id))
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }

  const handleEditClick = (id: GridRowId) => () => {
    navigate(`/milestone/${id}/edit`)
  }

  const columns: GridColDef[] = [
    { field: 'title', headerName: 'Titre Accordé', flex: 1, minWidth: 200 },
    {
      field: 'value',
      headerName: 'Seuil de Points/Temps',
      type: 'number',
      width: 200,
    },
    {
      field: 'id',
      headerName: 'ID',
      flex: 1,
      minWidth: 250,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Modifier"
          onClick={handleEditClick(id)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Supprimer"
          onClick={handleDeleteClick(id)}
          color="inherit"
        />,
      ],
    },
  ]

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          margin: '1rem',
          gap: '1rem',
        }}
      >
        <SearchBar
          onSearch={setRows}
          fields={searchFields}
          originalData={milestones}
        />
        <ExportButton
          fields={['id', 'value', 'title']}
          data={milestones}
          exportFileName="milestones_export"
        />
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        slots={{ toolbar: GridToolbar }}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
          sorting: {
            sortModel: [{ field: 'value', sort: 'asc' }],
          },
        }}
        pageSizeOptions={[10, 25, 50]}
        disableRowSelectionOnClick
      />
    </Box>
  )
}
